import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	categoryContainer: {
		display: 'flex',
		gap: token('space.100'),
		marginBottom: token('space.100'),
	},
	categoryItem: {
		height: '32px',
		minWidth: '80px',
		flex: '1',
		backgroundColor: token('color.skeleton'),
		borderRadius: token('radius.medium'),
	},
});

export const SnippetCategorySelectorSkeleton = () => {
	return (
		<Inline space="space.100">
			<Box xcss={styles.categoryItem} />
			<Box xcss={styles.categoryItem} />
			<Box xcss={styles.categoryItem} />
		</Inline>
	);
};
